import type { FC, ReactNode } from "react"

import PermissionDeniedAlert from "@/components/common/Alerts/PermissionDeniedAlert"
import type { PermissionActionType } from "@/constants/permissions"
import { usePermissionManager } from "@/hooks/usePermissionManager"

interface PermissionContainerWrapperProps {
  permissions: PermissionActionType[]
  children: ReactNode
}

const PermissionContentWrapper: FC<PermissionContainerWrapperProps> = ({ permissions, children }) => {
  const { hasPermissions } = usePermissionManager()

  if (hasPermissions(permissions)) {
    return children
  } else {
    return <PermissionDeniedAlert />
  }
}

export default PermissionContentWrapper
